import { useState } from "react";
import { LegalDialog } from "./LegalDialog";

const DOCS = { privacy_policy: "Informativa privacy", cookie_policy: "Cookie policy" };

export const PrivacyConsent = ({ checked, onChange, testId = "privacy-consent-checkbox", className = "" }) => {
  const [openDoc, setOpenDoc] = useState(null);
  const link = (slug, label, id) => (
    <button type="button" onClick={() => setOpenDoc(slug)} className="text-forest underline underline-offset-2 hover:text-brand" data-testid={`${testId}-${id}-link`}>{label}</button>
  );
  return (
    <>
      <label className={`flex items-start gap-2 text-xs text-sage cursor-pointer ${className}`} data-testid={`${testId}-label`}>
        <input type="checkbox" checked={checked} onChange={(e) => onChange(e.target.checked)} required className="mt-0.5 h-4 w-4 accent-[#2D5016] shrink-0" data-testid={testId} />
        <span>
          Ho letto l'{link("privacy_policy", "informativa privacy", "privacy")} e la{" "}
          {link("cookie_policy", "cookie policy", "cookie")} di Melaverde Srl e acconsento al trattamento dei dati necessari *
        </span>
      </label>
      <LegalDialog slug={openDoc} title={DOCS[openDoc] || ""} open={Boolean(openDoc)} onOpenChange={(o) => { if (!o) setOpenDoc(null); }} />
    </>
  );
};
